import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: "4px",
    background: "#FFFFFF",
    boxShadow:
      "0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)",
  },
  list: {
    "& li": {
      color: "#000000DE",
      "& svg": {
        marginRight: "10px",
        color: "#000000DE",
      },
    },
  },
}));
